import { makeStyles } from '@material-ui/core';

import { neutral } from 'shared/styles/colors';

export default makeStyles(theme => ({
  articleContainer: {
    width: '100%',
    height: '100vh',
    overflowY: 'auto',
    position: 'relative',
    backgroundColor: neutral.white,
    [theme.breakpoints.up('md')]: {
      borderTop: `0.5rem solid ${neutral.white}`,
      padding: '1rem',
      backgroundColor: 'transparent',
    },
  },
  page: {
    backgroundColor: neutral['20'],
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
}));
